import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PreviewContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 1000;
  background: ${({ $bgColor }) => $bgColor};
  border: 3px solid ${({ $borderColor }) => $borderColor};
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: ${({ $shadowLight }) => $shadowLight};
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 200px;
  max-width: 300px;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  transform: translate(-50%, -50%);
  animation: dragPulse 1.5s ease-in-out infinite;

  @keyframes dragPulse {
    0%,
    100% {
      box-shadow: ${({ $shadowLight }) => $shadowLight};
    }
    50% {
      box-shadow: ${({ $shadowStrong }) => $shadowStrong};
    }
  }
`;

const ModuleTypeLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  text-transform: capitalize;
`;

/**
 * DragPreview component - Shows a minimal floating preview while dragging
 *
 * @param {Object} props
 * @param {number} props.x - X position of the cursor
 * @param {number} props.y - Y position of the cursor
 * @param {string} props.moduleType - The type of module being dragged
 * @param {React.Component} props.IconComponent - The icon component to render
 * @param {string} props.themeColor - Theme color for styling
 * @param {string} props.bgColor - Background color
 * @param {string} props.shadowLight - Light shadow for animation
 * @param {string} props.shadowStrong - Strong shadow for animation
 */
const DragPreview = ({ x, y, moduleType, IconComponent, themeColor, bgColor, shadowLight, shadowStrong }) => {
  const { t } = useTranslation();

  return (
    <PreviewContainer $x={x} $y={y} $bgColor={bgColor} $borderColor={themeColor} $shadowLight={shadowLight} $shadowStrong={shadowStrong}>
      <IconComponent size='small' color={themeColor} />
      <ModuleTypeLabel $color={themeColor}>{t('editCourse.dragPreviewLabel', { moduleType })}</ModuleTypeLabel>
    </PreviewContainer>
  );
};

export default DragPreview;
